import React from 'react';
import { compose } from 'recompose';
import { AdminLibrary } from '../../components/scenes/Admin/Library';
import Layout from '../../utils/layout';
import {
  withAuthorization,
  withEmailVerification,
} from '../../utils/Session';

const condition = (authUser) => !!authUser;
const AdminPage = compose(
  withEmailVerification,
  withAuthorization(condition),
)(AdminLibrary);

export default () => (
  <Layout>
    <AdminPage />
  </Layout>
);
